export const EVENT_DATE_ISO = "2026-11-12T19:00:00-05:00";
export const EVENT_DURATION_MINUTES = 90;
export const EVENT_TIMEZONE = "America/New_York";
export const EVENT_TITLE = "Weaponized Credit to Capital — Live Class";
export const EVENT_LOCATION = "Live on Zoom";
export const EVENT_DETAILS = "Hosted by Jay Shelton · J11 · Educate II Elevate";

export const EVENT_DATE = new Date(EVENT_DATE_ISO);
export const EVENT_END_DATE = new Date(EVENT_DATE.getTime() + EVENT_DURATION_MINUTES * 60000);

const clean = (s) => s.replace(/[\u202f\u00a0]/g, " ");

export const EVENT_DAY_LABEL = clean(
  new Intl.DateTimeFormat("en-US", { timeZone: EVENT_TIMEZONE, weekday: "long", month: "long", day: "numeric" }).format(EVENT_DATE)
);

export const EVENT_TIME_LABEL = clean(
  new Intl.DateTimeFormat("en-US", { timeZone: EVENT_TIMEZONE, hour: "numeric", minute: "2-digit", hour12: true }).format(EVENT_DATE)
);

export const EVENT_DATE_LABEL = `${EVENT_DAY_LABEL} · ${EVENT_TIME_LABEL} ET`;

export const REPLAY_DEADLINE_ISO = "2026-11-14T23:59:00-05:00";
export const REPLAY_DEADLINE = new Date(REPLAY_DEADLINE_ISO);
